import { render, staticRenderFns } from "./MediaBadge.vue?vue&type=template&id=63ceced2&"
import script from "./MediaBadge.vue?vue&type=script&lang=js&"
export * from "./MediaBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports